/**
 * Список изменений ведём руками: сюда попадает то, что заметит пользователь,
 * а не каждый коммит. Новая запись — сверху, дата в формате ISO.
 *
 * Пометка «новое» у пункта меню считается от `date` самой верхней записи:
 * если она новее той, что пользователь уже открывал, точка загорается.
 */
export interface ChangelogEntry {
  date: string;
  title: string;
  items: string[];
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    date: '2026-09-18',
    title: 'Выгрузки собраны на одном экране',
    items: [
      'Отчёты больше не разложены по вкладкам: «Статистика → Выгрузить отчёт» открывает список из пяти карточек, у каждой написано, какой файл получится.',
      'Добавились «Топ видео» — самые просматриваемые ролики с топовыми комментариями, и «Презентация» — PDF для клиента.',
      'Кнопка «Отчёт министру» теперь называется «Скачать Word»: что это за отчёт, объясняет описание карточки.',
    ],
  },
  {
    date: '2026-09-17',
    title: 'Меню из трёх разделов',
    items: [
      'Восемь пунктов меню свелись к трём: «Статистика», «Публикации», «Аккаунты». Прежние адреса продолжают работать.',
      'Аналитика, авто-отчёты и дашборд стали вкладками «Статистики»: Сводка, По аккаунтам, По ссылкам, Средние просмотры, Хронология.',
      'Шаблоны оформления теперь видно списком — вкладка в «Аккаунтах». Раньше в редактор можно было попасть только через «⋯» на карточке.',
      'Создание Reels и поста слилось в один экран с переключателем формата; выбор аккаунтов поднят в начало формы.',
      'Аватарки аккаунтов больше не пропадают: приложение хранит свою копию, а не ссылку Instagram, которая жила две недели.',
    ],
  },
];
